(function () {
  'use strict';
  var element = document.getElementById('gs-configurator-checkout-settings');
  if (!element || window.__gsConfiguratorCheckoutGuard) return;
  var settings;
  try { settings = JSON.parse(element.getAttribute('data-settings')); } catch (_) { return; }
  var shopify = window.Shopify || {};
  var theme = shopify.theme || {};
  if (settings.shopId !== '94574346627' || shopify.shop !== settings.shop || !['200236302723', '200278704515', '200281620867', '200292041091', '200297152899'].includes(String(theme.id)) || !['main', 'unpublished'].includes(String(theme.role).toLowerCase())) return;
  if (![settings.shop, 'getswitches.com', 'www.getswitches.com'].includes(window.location.hostname)) return;
  var variantId = '56656171237763';
  var productId = '15422213030275';
  var cart = settings.cart;
  var pending = false;
  var waitingForCartWrite = false;
  var targetAddPending = false;
  var targetMayBePresent = false;
  var targetAddStarted = 0;
  var lastCheckoutSource = null;
  var checkoutAttempt = null;
  var departedAttempt = null;
  var permitted = new WeakSet();
  var bypass = new WeakSet();
  var checkoutSelector = '[name="checkout"],a[href*="/checkout"],.additional-checkout-buttons,.shopify-payment-button,[data-shopify="payment-button"]';
  var addSelector = '[name="add"],.m-add-to-cart,.shopify-payment-button,[data-shopify="payment-button"]';

  function isTarget(item) { return item && String(item.variant_id || item.id) === variantId; }
  function hasTarget(value) { return value && Array.isArray(value.items) && value.items.some(isTarget); }
  function propsPresent(item) {
    var props = item.properties;
    return props && !Array.isArray(props) && ['Plate Size', 'Plate Finish', 'Controls & Screws Finish'].every(function (key) { return typeof props[key] === 'string' && props[key].trim(); }) && Object.keys(props).some(function (key) { return /^(?:Position|Module) ?1$/.test(key) && typeof props[key] === 'string' && props[key].trim(); });
  }
  function acceptedCart(value) {
    if (!value || !Array.isArray(value.items)) return false;
    var target = value.items.filter(isTarget);
    if (!target.length) return true;
    if (window.is_draft_order !== true || !Array.isArray(window.hulk_inventory_arr) || window.hulk_inventory_arr.length || typeof window.hulkappsCheckout !== 'function') return false;
    return target.every(function (item) {
      return propsPresent(item) && typeof item.key === 'string' && Number.isInteger(item.quantity) && item.quantity > 0;
    });
  }
  function cartProblem(value) {
    return value && Array.isArray(value.items) && value.items.some(function (item) { return isTarget(item) && !propsPresent(item); }) ? 'unconfigured' : 'blocked';
  }
  function targetForm(form) {
    if (!form || form.tagName !== 'FORM') return false;
    var input = form.querySelector('[name="id"]');
    return Boolean(input && String(input.value) === variantId || String(form.dataset.productId) === productId);
  }
  function stop(event) { event.preventDefault(); event.stopImmediatePropagation(); }
  function notice(key, source) {
    source = source || lastCheckoutSource;
    var scope = source && source.isConnected && source.closest && source.closest('m-cart-drawer,m-cart,.m-product-card,product-form');
    var container = source && source.isConnected && source.closest && source.closest('.m-cart-drawer__footer--wrapper,.m-cart__checkout');
    container = container || scope && scope.querySelector('.m-cart-drawer__footer--wrapper,.m-cart__checkout') || document.querySelector('m-cart-drawer.m-cart-drawer--active .m-cart-drawer__footer--wrapper,m-cart .m-cart__checkout') || scope || document.body;
    var output = container.querySelector('[data-gs-checkout-message]');
    if (!output) { output = document.createElement('p'); output.dataset.gsCheckoutMessage = ''; output.setAttribute('role', 'alert'); output.style.margin = '0 0 12px'; container.prepend(output); }
    output.textContent = key === null ? '' : settings.messages[key] || settings.messages.blocked;
  }
  function knownTarget() {
    return targetMayBePresent || hasTarget(cart) || hasTarget(window.hulkapps && window.hulkapps.cart) || Boolean(document.querySelector('[data-key^="' + variantId + ':"]'));
  }
  function nativeInvoice(value) {
    if (typeof value !== 'string') return false;
    try {
      var url = new URL(value, window.location.origin);
      return url.protocol === 'https:' && [settings.shop, 'getswitches.com', 'www.getswitches.com', 'checkout.shopify.com'].includes(url.hostname) && /\/(?:checkouts|invoices)\//.test(url.pathname);
    } catch (_) { return false; }
  }
  function installDraftGuard() {
    var original = window.hulkappsCreateDraftOrder;
    if (typeof original !== 'function' || original.__gsZeroGuard) return;
    function guarded(primary, legacy, success, failure) {
      var value = legacy && legacy.cart_json && legacy.cart_json.cart;
      if (!hasTarget(value)) return original.apply(this, arguments);
      var updateSource = checkoutAttempt && checkoutAttempt.updateSource || lastCheckoutSource;
      if (!checkStudioUpdates(updateSource, value)) {
        if (typeof failure === 'function') failure.call(this);
        return;
      }
      if (!acceptedCart(value)) {
        notice(cartProblem(value));
        if (typeof failure === 'function') failure.call(this);
        return;
      }
      var attempt = checkoutAttempt && !checkoutAttempt.helperStarted ? checkoutAttempt : null;
      if (attempt) attempt.helperStarted = true;
      var args = Array.prototype.slice.call(arguments);
      args[2] = function (result) {
        if (!nativeInvoice(result)) {
          notice('blocked');
          if (typeof failure === 'function') return failure.apply(this, arguments);
          return;
        }
        if (attempt && attempt === checkoutAttempt) attempt.complete = true;
        return success.apply(this, arguments);
      };
      args[3] = function () {
        if (attempt) attempt.complete = false;
        notice('unavailable');
        if (typeof failure === 'function') return failure.apply(this, arguments);
      };
      return original.apply(this, args);
    }
    guarded.__gsZeroGuard = true;
    window.hulkappsCreateDraftOrder = guarded;
  }
  function freshCart() {
    var controller = new AbortController();
    var timer = setTimeout(function () { controller.abort(); }, 8000);
    var root = shopify.routes && shopify.routes.root || '/';
    return fetch(root + 'cart.js', { credentials: 'same-origin', cache: 'no-store', signal: controller.signal })
      .then(function (response) { if (!response.ok) throw new Error('CART_UNAVAILABLE'); return response.json(); })
      .then(function (value) { if (!value || !Array.isArray(value.items)) throw new Error('CART_UNAVAILABLE'); cart = value; if (!targetAddPending) targetMayBePresent = hasTarget(value); return value; })
      .finally(function () { clearTimeout(timer); });
  }
  function termsAccepted(source, form) {
    var scope = source && source.closest && source.closest('m-cart-drawer,m-cart') || form && form.closest('m-cart-drawer,m-cart') || form;
    var unchecked = scope && scope.querySelector('[name="agree_terms"]:not(:checked)');
    if (!unchecked) return true;
    if (typeof unchecked.reportValidity === 'function') unchecked.reportValidity();
    notice('terms', source || form);
    return false;
  }

  function studioUpdateProblem(source, value) {
    var root = source && source.closest && source.closest('m-cart,m-cart-drawer');
    if (!['200292041091', '200297152899'].includes(String(theme.id)) || !root || !root.querySelector('[data-gs-studio-item]')) return null;
    var readiness = window.__gsStudioCartReadiness;
    if (!readiness || typeof readiness.status !== 'function') return 'updates_failed';
    return readiness.status(source, value);
  }
  function checkStudioUpdates(source, value) {
    var reason = studioUpdateProblem(source, value);
    waitingForCartWrite = Boolean(reason);
    if (reason) notice(reason, source);
    return !reason;
  }

  function submitCheckout(source, form) {
    lastCheckoutSource = source || form;
    var updateSource = lastCheckoutSource && lastCheckoutSource.closest && lastCheckoutSource.closest('m-cart,m-cart-drawer') || lastCheckoutSource;
    if (targetAddPending) { notice(Date.now() - targetAddStarted > 15000 ? 'add_pending' : 'checking', source); return; }
    if (pending || window.hulkapps_checkout_in_progress || !termsAccepted(source, form)) return;
    if (!checkStudioUpdates(updateSource)) return;
    checkoutAttempt = null;
    departedAttempt = null;
    pending = true;
    notice('checking', source);
    freshCart().then(function (value) {
      if (!checkStudioUpdates(updateSource, value)) return;
      if (!hasTarget(value)) {
        if (source && source.isConnected) { bypass.add(source); try { source.click(); } finally { bypass.delete(source); } }
        else if (form && form.isConnected) { bypass.add(form); try { form.requestSubmit(); } finally { bypass.delete(form); } }
        return;
      }
      if (!acceptedCart(value)) { notice(cartProblem(value), source); return; }
      if (form && !form.noValidate && !(source && source.formNoValidate) && typeof form.checkValidity === 'function' && !form.checkValidity()) { notice(null, source); form.reportValidity(); return; }
      if (typeof window.IntegrationCheckoutClick === 'function') { notice('blocked', source); return; }
      installDraftGuard();
      if (!window.hulkappsCreateDraftOrder || !window.hulkappsCreateDraftOrder.__gsZeroGuard) { notice('blocked', source); return; }
      checkoutAttempt = { source: source || form, updateSource: updateSource, complete: false, helperStarted: false, controls: Array.prototype.filter.call(document.querySelectorAll(window.checkout_selectors || '[name="checkout"]'), function (node) { return 'disabled' in node && !node.disabled; }) };
      window.hulkappsCheckout(null);
    }).catch(function () { notice('unavailable', source); }).finally(function () { pending = false; });
  }
  function checkoutForm(form) {
    if (!form || form.tagName !== 'FORM') return false;
    try { var url = new URL(form.action, window.location.origin); return url.origin === window.location.origin && /\/(?:cart|checkout)\/?$/.test(url.pathname); } catch (_) { return false; }
  }
  function onClick(event) {
    var target = event.target && event.target.closest ? event.target : null;
    if (!target) return;
    var add = target.closest(addSelector);
    var form = add && (add.form || add.closest('form'));
    if (add && targetForm(form)) {
      if (permitted.has(form) && add.matches('[name="add"],.m-add-to-cart')) return;
      stop(event); notice('configure', add); return;
    }
    var control = target.closest(checkoutSelector);
    if (!control || bypass.has(control)) return;
    if (control.matches('.additional-checkout-buttons,.shopify-payment-button,[data-shopify="payment-button"]') && !knownTarget()) return;
    if (control.tagName === 'A') {
      try { var url = new URL(control.href, window.location.origin); if (url.origin !== window.location.origin || !/(?:^|\/)checkout(?:\/|$)/.test(url.pathname)) return; } catch (_) { return; }
    }
    stop(event);
    submitCheckout(control, control.form || control.closest('form'));
  }
  function onSubmit(event) {
    var form = event.target;
    if (bypass.has(form) || event.submitter && bypass.has(event.submitter)) return;
    if (targetForm(form)) {
      if (permitted.has(form)) return;
      stop(event); notice('configure', form); return;
    }
    if (!checkoutForm(form)) return;
    var submitter = event.submitter;
    if (submitter && submitter.name !== 'checkout') return;
    if (!submitter) {
      var action = new URL(form.action, window.location.origin);
      var checkoutInput = form.querySelector('input[name="checkout"]:not(:disabled)');
      if (!/(?:^|\/)checkout\/?$/.test(action.pathname) && !checkoutInput) return;
    }
    stop(event); submitCheckout(submitter, form);
  }
  function hideTargetBuyNow() {
    document.querySelectorAll('form').forEach(function (form) {
      if (!targetForm(form)) return;
      form.querySelectorAll('.shopify-payment-button,[data-shopify="payment-button"],.m-product-dynamic-checkout').forEach(function (node) { node.hidden = true; node.style.display = 'none'; });
    });
  }
  document.addEventListener('gs:cart-write-settled', function () { if (waitingForCartWrite && !studioUpdateProblem(lastCheckoutSource)) { waitingForCartWrite = false; notice(null); } });
  document.addEventListener('gs:cart-write-failed', function () { if (waitingForCartWrite) notice('updates_failed'); });
  document.addEventListener('click', onClick, true);
  document.addEventListener('submit', onSubmit, true);
  document.addEventListener('cart:updated', function (event) { if (event.detail && event.detail.cart && Array.isArray(event.detail.cart.items)) cart = event.detail.cart; });
  document.addEventListener('product-ajax:added', function (event) { if (event.detail && isTarget(event.detail.product)) targetAddPending = false; });
  document.addEventListener('product-ajax:error', function () { if (targetAddPending) notice('add_pending'); });
  document.addEventListener('hpo_before_checkout', installDraftGuard);
  document.addEventListener('HulkApps:loaded', installDraftGuard);
  document.addEventListener('shopify:section:load', hideTargetBuyNow);
  document.addEventListener('DOMContentLoaded', hideTargetBuyNow);
  window.addEventListener('pagehide', function () { departedAttempt = checkoutAttempt && checkoutAttempt.complete ? checkoutAttempt : null; });
  window.addEventListener('pageshow', function (event) {
    var attempt = departedAttempt;
    departedAttempt = null;
    if (!event.persisted || !attempt || attempt !== checkoutAttempt || !attempt.complete || targetAddPending) return;
    checkoutAttempt = null;
    pending = false;
    window.hulkapps_checkout_in_progress = false;
    attempt.controls.forEach(function (node) { if (node.isConnected && node.disabled) node.disabled = false; });
    notice(null, attempt.source);
  });
  installDraftGuard();
  hideTargetBuyNow();
  window.__gsConfiguratorCheckoutGuard = Object.freeze({
    submitConfigured: function (form, button, expected) {
      var text = (document.querySelector('#calculated_option_total') || {}).textContent || '';
      var total = Number(text.replace(/[^0-9.-]/g, ''));
      if (!targetForm(form) || !Number.isFinite(expected) || expected <= 0 || !Number.isFinite(total) || Math.abs(total - expected) > 0.01) throw new Error('CONFIGURATOR_PRICE_UNCONFIRMED');
      if (targetAddPending) throw new Error('CONFIGURATOR_ADD_PENDING');
      if (typeof form.checkValidity === 'function' && !form.checkValidity()) { form.reportValidity(); throw new Error('CONFIGURATOR_FIELDS_REQUIRED'); }
      targetAddPending = true;
      targetAddStarted = Date.now();
      targetMayBePresent = true;
      permitted.add(form);
      try { if (typeof form.requestSubmit === 'function') form.requestSubmit(button); else button.click(); } finally { permitted.delete(form); }
    }
  });
})();
